import get from 'lodash/get';
import * as types from '../constants/types';

const initialValue = {};

const reducers = (state = initialValue, action) => {
  const { userId, unitNumber, number, subjectId, isVisited, visitedSubunits } =
    action.payload || {};

  switch (action.type) {
    case types.SET_VISITED_SUBUNITS:
      return {
        ...state,
        [`${subjectId}-${userId}`]: {
          ...get(state, `${subjectId}-${userId}`, {}),
          [unitNumber]: {
            ...get(state, [`${subjectId}-${userId}`, unitNumber], {}),
            [number]: isVisited,
          },
        },
      };
    case types.UPDATE_ALL_VISITED_SUBUNITS:
      return {
        ...state,
        [`${subjectId}-${userId}`]: {
          ...get(state, `${subjectId}-${userId}`, {}),
          [unitNumber]: {
            ...visitedSubunits,
          },
        },
      };
    default:
      return state;
  }
};

export default reducers;
